import { z } from 'zod';
import { employmentApi } from '../../../api';
import { EMPLOYMENT_EVENT_TYPES } from '../../../../constants/employmentEventTypes';
import { EVENT_ACTOR_TYPES } from '../../../../constants/employmentActorTypes';
import { employmentEpisodeIdSchema } from '../episodeAddress';

/**
 * Validation schema for resignation submission
 */
const submitResignationSchema = z.object({
  employeeId: z.uuid(),
  employmentEpisodeId: employmentEpisodeIdSchema, // ADR-155 §6
  resignationDate: z.iso.date('Resignation date must be in ISO format (YYYY-MM-DD)'),
  resignationReason: z.string().min(1, 'Resignation reason is required')
});

/**
 * Submit Resignation
 *
 * @param {Object} payload - Resignation data
 * @param {string} payload.employeeId - Required
 * @param {string} payload.resignationDate - Required - ISO date format (YYYY-MM-DD)
 * @param {string} payload.resignationReason - Required
 * @param {string} [actorType='User'] - Actor type (System, User, Import)
 * @returns {Promise<Object>}
 * @throws {z.ZodError} - If validation fails
 */
export const submitResignation = async (payload, actorType = EVENT_ACTOR_TYPES.USER) => {
  // Validate payload
  const validatedPayload = submitResignationSchema.parse(payload);

  return await employmentApi.triggerEmploymentEvents({
    metadata: {
      actorType
    },
    events: [{
      type: EMPLOYMENT_EVENT_TYPES.RESIGNATION_SUBMITTED,
      payload: validatedPayload
    }]
  });
};
